/*
	Bootstrap 4 Mega Dropdown Menu (https://mm-united.com) Copyright 2016 - 2018 MM United. All Rights Reserved.
	Licensed under Regular License (http://codecanyon.net/licenses/regular) or Extended License (http://codecanyon.net/licenses/extended)
	We will take legal action against those who copy our HTML content, CSS style sheets and JavaScript functions without a license.
*/


// MDM
window.mdm = {};

// MDM plugin functions
window.mdm.fn = {
	getOptions: function(opts) {
		if (typeof(opts) == 'object') {
			return opts;
		}

		else if (typeof(opts) == 'string') {
			try {
				return JSON.parse(opts.replace(/'/g,'"').replace(';',''));
			}

			catch(e) {
				return {};
			}
		}

		else {
			return {};
		}
	}
};

// Animate
(function(mdm, $) {

	mdm = mdm || {};

	var instanceName = '__animate';

	var Animate = function($el, opts) {
		return this.initialize($el, opts);
	};

	Animate.defaults = {
		accX: 0,
		accY: -80,
		delay: 100,
		duration: '500ms'
	};

	Animate.prototype = {
		initialize: function($el, opts) {
			if ($el.data(instanceName)) {
				return this;
			}

			this.$el = $el;

			this
				.setData()
				.setOptions(opts)
				.build();

			return this;
		},

		setData: function() {
			this.$el.data(instanceName, this);

			return this;
		},

		setOptions: function(opts) {
			this.options = $.extend(true, {}, Animate.defaults, opts, {
				container: this.$el
			});

			return this;
		},

		build: function() {
			var self = this,
				$el = this.options.container,
				delay = 0,
				duration = this.options.duration,
				elTopDistance = $el.offset().top,
				windowTopDistance = $(window).scrollTop();

			$el.addClass('appear-animation animated');

			if (!$('html').hasClass('no-csstransitions') && $(window).width() > 767 && elTopDistance > windowTopDistance) {

				$el.appear(function() {

					$el.one('animation:show', function(ev) {
						delay = ($el.attr('data-appear-animation-delay') ? $el.attr('data-appear-animation-delay') : self.options.delay);
						duration = ($el.attr('data-appear-animation-duration') ? $el.attr('data-appear-animation-duration') : self.options.duration);

						if (duration != '750ms') {
							$el.css('animation-duration', duration);
						}

						$el.css('animation-delay', delay + 'ms');

						$el.addClass($el.attr('data-appear-animation') + ' appear-animation-visible');
					});

					$el.trigger('animation:show');

				}, {
					accX: self.options.accX,
					accY: self.options.accY
				});

			} else {

				$el.addClass('appear-animation-visible');

			}

			return this;
		}
	};

	$.extend(mdm, {
		Animate: Animate
	});

	// jquery plugin
	$.fn.mdmAnimate = function(opts) {
		return this.map(function() {
			var $this = $(this);

			if ($this.data(instanceName)) {
				return $this.data(instanceName);
			}

			else {
				return new Animate($this, opts);
			}
		});
	};
}).apply(this, [window.mdm, jQuery]);

// Match Height
(function(mdm, $) {

	mdm = mdm || {};

	var instanceName = '__matchHeight';

	var MatchHeight = function($el, opts) {
		return this.initialize($el, opts);
	};

	MatchHeight.defaults = {
		byRow: true,
		property: 'height',
		target: null,
		remove: false
	};

	MatchHeight.prototype = {
		initialize: function($el, opts) {
			if ($el.data(instanceName)) {
				return this;
			}

			this.$el = $el;
			this
				.setData()
				.setOptions(opts)
				.build();

			return this;
		},

		setData: function() {
			this.$el.data(instanceName, this);
			return this;
		},

		setOptions: function(opts) {
			this.options = $.extend(true, {}, MatchHeight.defaults, opts, {
				container: this.$el
			});

			return this;
		},

		build: function() {
			if (!($.isFunction($.fn.matchHeight))) {
				return this;
			}

			var self = this;

			self.options.container.matchHeight(self.options);

			return this;
		}

	};

	$.extend(mdm, {
		MatchHeight: MatchHeight
	});

	// jquery plugin
	$.fn.mdmMatchHeight = function(opts) {
		return this.map(function() {
			var $this = $(this);

			if ($this.data(instanceName)) {
				return $this.data(instanceName);
			} else {
				return new MatchHeight($this, opts);
			}

		});
	}

}).apply(this, [window.mdm, jQuery]);

// Sticky
(function(mdm, $) {

	mdm = mdm || {};

	var instanceName = '__sticky';

	var Sticky = function($el, opts) {
		return this.initialize($el, opts);
	};

	Sticky.defaults = {
		minWidth: 991,
		activeClass: 'sticky-active'
	};

	Sticky.prototype = {
		initialize: function($el, opts) {
			if ( $el.data( instanceName ) ) {
				return this;
			}

			this.$el = $el;

			this
				.setData()
				.setOptions(opts)
				.build();

			return this;
		},

		setData: function() {
			this.$el.data(instanceName, this);

			return this;
		},

		setOptions: function(opts) {
			this.options = $.extend(true, {}, Sticky.defaults, opts, {
				container: this.$el
			});

			return this;
		},

		build: function() {
			if (!($.isFunction($.fn.pin))) {
				return this;
			}

			var self = this,
				$window = $(window);

			self.options.container.pin(self.options);

			$window.resize(function() {
				self.options.container.removeAttr('style').removeData('pin');
				self.options.container.pin(self.options);
				$window.trigger('scroll');
			});

			return this;
		}
	};

	$.extend(mdm, {
		Sticky: Sticky
	});

	// jquery plugin
	$.fn.mdmSticky = function(opts) {
		return this.map(function() {
			var $this = $(this);

			if ($this.data(instanceName)) {
				return $this.data(instanceName);
			}

			else {
				return new Sticky($this, opts);
			}
		});
	}
}).apply(this, [ window.mdm, jQuery ]);

// Nav
(function(mdm, $) {

	mdm = mdm || {};

	var initialized = false;

	$.extend(mdm, {

		Nav: {
			defaults: {
				container: $('#mdmNav'),
				scrollDelay: 600,
				scrollAnimation: 'easeOutQuad'
			},

			initialize: function($container, opts) {
				if (initialized) {
					return this;
				}

				initialized = true;
				this.$container = ($container || this.defaults.container);
				this
					.setOptions(opts)
					.build()
					.events();

				return this;
			},

			setOptions: function(opts) {
				this.options = $.extend(true, {}, this.defaults, opts, mdm.fn.getOptions(this.$container.data('plugin-options')));
				return this;
			},

			build: function() {
				var self = this,
				$html = $('html'),
				$header = $('#header');

				// Arrows
				$header.find('.dropdown-toggle, .dropdown-submenu > a').append($('<i />').addClass('fas fa-caret-down'));

				// Sidebar Right (Reverse Dropdown)
				if($html.hasClass('sidebar-right')) {
					$header.find('.dropdown-submenu').addClass('dropdown-reverse');
				}

				else {

					// Reverse
					self.checkReverse = function() {
						self.$container.find('.dropdown-submenu').removeClass('dropdown-reverse');
						self.$container.find('.dropdown-submenu:not(.manual)').each(function() {
							if(!$(this).find('.dropdown-menu').visible( false, true, 'horizontal' )  ) {
								$(this).addClass('dropdown-reverse');
							}
						});
					}

					self.checkReverse();
	 				$(document).ready(function(){
		 				$(window).resize(function() {
							self.checkReverse();
		 				});
	 				});
				}

				return this;
			},

			events: function() {
				var self    = this,
					$html   = $('html'),
					$header = $('#header'),
					$window = $(window),
					headerBodyHeight = $('.header-body').outerHeight();

				$header.find('a[href="#"]').on('click', function(e) {
					e.preventDefault();
				});

				// Mobile Arrows
				$header.find('.dropdown-toggle[href="#"], .dropdown-submenu a[href="#"], .dropdown-toggle[href!="#"] .fa-caret-down, .dropdown-submenu a[href!="#"] .fa-caret-down').on('click', function(e) {
					e.preventDefault();
					if ($window.width() < 992) {
						$(this).closest('li').toggleClass('opened');
					}

					// Header Body Height
					$('.header-body').animate({
				 		height: ($('.header-nav-mdm nav').outerHeight() + headerBodyHeight) + 20
				 	}, 0);
				});

				// Mobile Devices with normal resolutions
				if('ontouchstart' in document.documentElement) {
					$header.find('.dropdown-toggle:not([href="#"]), .dropdown-submenu > a:not([href="#"])')
						.on('touchstart', function(e) {
							if($window.width() > 991) {

								e.stopPropagation();
								e.preventDefault();

								var li = $(this).closest('li');

								if(e.handled !== true) {

									if(li.hasClass('tapped')) {
										location.href = $(this).attr('href');
									}

									li.addClass('tapped');

									e.handled = true;
								}

								else {
									return false;
								}

								li.addClass('open');

								return false;
							}
						})
						.on('blur', function(e) {
							$(this).closest('li').removeClass('tapped');
						});
				}

				// Collapse Nav
				$header.find('[data-collapse-nav]').on('click', function(e) {
					$(this).parents('.collapse').removeClass('show');
				});

				// Header Body Height (mobile menu)
				$('.header-nav-mdm nav').on('show.bs.collapse', function () {
				 	$('.header-body').animate({
				 		height: ($(this).outerHeight() + headerBodyHeight) + 20
				 	});
				});

				// Header Body Height (collapse mobile menu)
				$('.header-nav-mdm nav').on('hide.bs.collapse', function () {
				 	$('.header-body').animate({
				 		height: headerBodyHeight
				 	}, function(){
				 		$(this).height('auto');
				 	});
				});

				// Sidebar - Change value of initial header body height
				$(document).ready(function(){
					if( $window.width() > 991 ) {
						var flag = false;

						$window.resize(function(){
							if( $window.width() < 992 && flag == false ) {
								headerBodyHeight = $('.header-body').outerHeight();
								flag = true;
							}
						});
					}
				});

				// Anchors Position
				$('[data-hash]').each(function() {

					var target = $(this).attr('href'),
					offset = ($(this).is("[data-hash-offset]") ? $(this).data('hash-offset') : 0);

					if($(target).get(0)) {
						$(this).on('click', function(e) {
							e.preventDefault();

							if( !$(e.target).is('i') ) {

								// Close Collapse (open)
								$(this).parents('.collapse.show').collapse('hide');

								self.scrollToTarget(target, offset);
							}

							return;
						});
					}
				});

				return this;
			},

			scrollToTarget: function(target, offset) {
				var self = this;

				$('body').addClass('scrolling');

				$('html, body').animate({
					scrollTop: $(target).offset().top - offset
				}, self.options.scrollDelay, self.options.scrollAnimation, function() {
					$('body').removeClass('scrolling');
				});

				return this;
			}
		}
	});
}).apply(this, [window.mdm, jQuery]);

// Sticky Header
(function(mdm, $) {

	mdm = mdm || {};

	var initialized = false;

	$.extend(mdm, {

		StickyHeader: {

			defaults: {
				container: $('#header'),
				headerBody: $('#header .header-body'),
				stickyEnabled: true,
				stickyEnableOnMobile: true,
				stickyStartAt: 0,
				stickyStartAtElement: false,
				stickySetTop: 0,
				stickyChangeLogo: false,
				stickyChangeLogoContainer: true
			},

			initialize: function($container, opts) {
				if (initialized) {
					return this;
				}

				initialized = true;
				this.$container = ($container || this.defaults.container);

				this
					.setOptions(opts)
					.build()
					.events();

				return this;
			},

			setOptions: function(opts) {
				this.options = $.extend(true, {}, this.defaults, opts, mdm.fn.getOptions(this.$container.data('plugin-options')));

				return this;
			},

			build: function() {

				var self = this,
					$html = $('html'),
					$window = $(window),
					sideBar = $html.hasClass('sidebar');

				// HTML Classes
				$html.addClass('sticky-header-enabled');

				if (parseInt(self.options.stickySetTop) < 0) {
					$html.addClass('sticky-header-negative');
				}

				// Set Start At
				if(self.options.stickyStartAtElement) {

					var $stickyStartAtElement = $(self.options.stickyStartAtElement);

					$(window).on('scroll resize', function() {
						self.options.stickyStartAt = $stickyStartAtElement.offset().top;
					});

					$(window).trigger('resize');
				}

				// Set Container Min-Height
				if( !sideBar ) {
					self.options.container.css('min-height', self.options.container.height());
				}

				// Check Sticky Header
				self.checkStickyHeader = function() {
					if ($window.scrollTop() >= parseInt(self.options.stickyStartAt)) {
						self.activateStickyHeader();
					} else {
						self.deactivateStickyHeader();
					}
				};

				// Activate Sticky Header
				self.activateStickyHeader = function() {

					if ($window.width() < 992) {
						if (!self.options.stickyEnableOnMobile) {
							self.deactivateStickyHeader();
							return;
						}
					} else {
						if (sideBar) {
							self.deactivateStickyHeader();
							return;
						}
					}

					$html.addClass('sticky-header-active');

					self.options.headerBody.css('top', self.options.stickySetTop);

					if (self.options.stickyChangeLogo) {
						self.changeLogo(true);
					}

					$.event.trigger({
						type: 'stickyHeader.activate'
					});
				};

				// Deactivate Sticky Header
				self.deactivateStickyHeader = function() {

					$html.removeClass('sticky-header-active');

					self.options.headerBody.css('top', 0);

					if (self.options.stickyChangeLogo) {
						self.changeLogo(false);
					}

					$.event.trigger({
						type: 'stickyHeader.deactivate'
					});
				};

				// Always Sticky
				if (parseInt(self.options.stickyStartAt) <= 0) {
					self.activateStickyHeader();
				}

				// Set Logo
				if (self.options.stickyChangeLogo) {

					var $logoContainer = self.options.container.find('.header-logo'),
						$logo = $logoContainer.find('img'),
						logoWidth = $logo.attr('width'),
						logoHeight = $logo.attr('height'),
						logoSmallTop = parseInt($logo.attr('data-sticky-top') ? $logo.attr('data-sticky-top') : 0),
						logoSmallWidth = parseInt($logo.attr('data-sticky-width') ? $logo.attr('data-sticky-width') : 'auto'),
						logoSmallHeight = parseInt($logo.attr('data-sticky-height') ? $logo.attr('data-sticky-height') : 'auto');

					if (self.options.stickyChangeLogoContainer) {
						$logoContainer.css({
							'width': $logo.outerWidth(true),
							'height': $logo.outerHeight(true)
						});
					}

					self.changeLogo = function(activate) {
						if(activate) {

							$logo.css({
								'top': logoSmallTop,
								'width': logoSmallWidth,
								'height': logoSmallHeight
							});
						}

						else {
							$logo.css({
								'top': 0,
								'width': logoWidth,
								'height': logoHeight
							});
						}
					}
				}

				// Sidebar
				var headerBodyHeight,
					flag = false;

				self.checkSideHeader = function() {
					if($window.width() < 992 && flag == false) {
						headerBodyHeight = self.options.headerBody.height();
						flag = true;
					}

					if(self.options.stickyStartAt == 0 && sideBar) {
						self.options.container.css('min-height', 0);
					}

					if(self.options.stickyStartAt > 0 && sideBar && $window.width() < 992) {
						self.options.container.css('min-height', headerBodyHeight);
					}
				}

				return this;
			},

			events: function() {
				var self = this;

				if (!self.options.alwaysStickyEnabled) {
					$(window).on('scroll resize', function() {
						self.checkStickyHeader();
					});
				} else {
					self.activateStickyHeader();
				}

				$(window).on('load resize', function(){
					self.checkSideHeader();
				});

				return this;
			}
		}
	});
}).apply(this, [window.mdm, jQuery]);







// Accordion Menu
(function(theme, $) {

    theme = theme || {};

    var instanceName = '__accordionMenu';

    var AccordionMenu = function($el, opts) {
        return this.initialize($el, opts);
    };

    AccordionMenu.defaults = {

    };

    AccordionMenu.prototype = {
        initialize: function($el, opts) {
            if ($el.data(instanceName)) {
                return this;
            }

            this.$el = $el;

            this
                .setData()
                .setOptions(opts)
                .build();

            return this;
        },

        setData: function() {
            this.$el.data(instanceName, this);

            return this;
        },

        setOptions: function(opts) {
            this.options = $.extend(true, {}, AccordionMenu.defaults, opts, {
                wrapper: this.$el
            });

            return this;
        },

        build: function() {
            var self = this,
                $el = this.options.wrapper;

            $el.find('li.menu-item.active').each(function() {
                var $this = $(this);

                if ($this.find('> .arrow').get(0))
                    $this.find('> .arrow').click();
            });

            $el.find('.arrow').click(function() {
                var $this = $(this),
                    $parent = $this.closest('li');

                $this.next().stop().slideToggle();
                if ($parent.hasClass('open')) {
                    $parent.removeClass('open');
                } else {
                    $parent.addClass('open');
                }
            });

            return this;
        }
    };

    // expose to scope
    $.extend(theme, {
        AccordionMenu: AccordionMenu
    });

    // jquery plugin
    $.fn.themeAccordionMenu = function(opts) {
        return this.map(function() {
            var $this = $(this);

            if ($this.data(instanceName)) {
                return $this.data(instanceName);
            } else {
                return new theme.AccordionMenu($this, opts);
            }

        });
    }

}).apply(this, [window.theme, jQuery]);
